export const copyToClipboard = copyURL => {
    try {
        navigator.clipboard.writeText(copyURL)
    } catch (err) {
        console.log('Failed to copy!')
    }
}